if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const workshopItems = window.MwWorkshopCart?.getSelectedItems(this);

        if (workshopItems) {
          if (!workshopItems.length) {
            this.handleErrorMessage('Select at least one session.');
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
            this.submitButton.removeAttribute('aria-disabled');
            return;
          }

          const payload = { items: workshopItems };

          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }

          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(payload);

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => this.handleCartResponse(response, workshopItems[0]?.id, evt))
            .catch((e) => console.error(e))
            .finally(() => this.finishSubmit(evt));

          return;
        }

        const formData = new FormData(this.form);

        if (!formData.get('id')) {
          this.handleErrorMessage(window.variantStrings?.unavailable || 'Choose a session first.');
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          this.submitButton.removeAttribute('aria-disabled');
          return;
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => this.handleCartResponse(response, formData.get('id'), evt))
          .catch((e) => console.error(e))
          .finally(() => this.finishSubmit(evt));
      }

      handleCartResponse(response, variantId, evt) {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });
        }
        this.error = false;

        const picker = this.closest('product-info')?.querySelector('[data-mw-workshop-picker]');
        if (picker) {
          picker.querySelectorAll('[data-mw-workshop-session].is-selected').forEach((session) => {
            session.classList.remove('is-selected');
            session.setAttribute('aria-pressed', 'false');
          });
          const productInfo = this.closest('product-info');
          const submitText =
            this.submitButton?.querySelector('.mw-workshop-purchase__submit-text') ||
            this.submitButton?.querySelector('span:not(.svg-wrapper):not(.mw-workshop-purchase__submit-inner)');
          if (submitText) submitText.textContent = 'Select session(s)';
          this.submitButton?.setAttribute('aria-disabled', 'true');
        }

        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                CartPerformance.measure('add:paint-updated-sections', () => {
                  this.cart.renderContents(response);
                });
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          CartPerformance.measure('add:paint-updated-sections', () => {
            this.cart.renderContents(response);
          });
        }
      }

      finishSubmit(evt) {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner')?.classList.add('hidden');
        CartPerformance.measureFromEvent('add:user-action', evt);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
